import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibSelectOption',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Boolean, Array, Number]
    },
    center: {
      type: Boolean
    },
    right: {
      type: Boolean
    },
    icon: {
      type: Boolean
    },
    multiple: {
      type: Boolean
    },
    flex: {
      type: Boolean
    },
    size: {
      type: String,
      default: '24px'
    },
    small: {
      type: Boolean
    },
    status: {
      type: Boolean
    },
    drillDownPlus: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    } // leftLabel: {
    //   type: Boolean
    // }

  },
  computed: {
    valueComputed: function valueComputed() {
      if (this.multiple && !this.value) {
        return [];
      }

      return this.value;
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value);
    },
    handleChangeDirect: function handleChangeDirect(e) {
      this.handleChange(e);
    },
    handleCheckboxClicked: function handleCheckboxClicked(context) {
      this.$emit('clicked', context);
    },
    handleRadioClicked: function handleRadioClicked(context) {
      this.$emit('clicked', context);
    }
  }
};